import { cn } from "../../lib/utils"

type SparklineProps = {
  values: number[]
  /** Render muted (e.g. a not-yet-synced marketplace). */
  dim?: boolean
  /** Override the default height (h-8) or add spacing — `cn` resolves the
   *  conflicting Tailwind height class. */
  className?: string
}

/** Minimal bar sparkline. Empty values keep a faint baseline so the cadence
 *  stays legible; the final bar (most recent) is emphasised. Shared by the
 *  dashboard GMV cards and the offer-health active-offers trend. */
export function Sparkline({ values, dim, className }: SparklineProps) {
  const max = Math.max(1, ...values)

  return (
    <div className={cn("flex h-8 items-end gap-px", className)} aria-hidden>
      {values.map((v, i) => (
        <div
          key={i}
          className={cn(
            "flex-1 rounded-sm transition-colors",
            barClass(dim, i === values.length - 1)
          )}
          style={{ height: `${Math.max(6, (v / max) * 100)}%` }}
        />
      ))}
    </div>
  )
}

function barClass(dim: boolean | undefined, isLast: boolean): string {
  if (dim) {
    return "bg-muted"
  }
  if (isLast) {
    return "bg-muted-foreground/60 group-hover:bg-muted-foreground/80"
  }
  return "bg-muted-foreground/25 group-hover:bg-muted-foreground/40"
}
